import { type OpenApiSchemaDraftMenuItem } from '#shared/api/schema';

/*
 * Подготавливаем MenuItem для сохранения
 */
export const mapMenuItemToSaving = ({ link, ...menuItem }: OpenApiSchemaDraftMenuItem): OpenApiSchemaDraftMenuItem => {
    /** Вычищаем все пустые значения родителя, чтобы не отправлять на бэк */
    if (!menuItem.parent_id) {
        delete menuItem.parent_id;
    }

    return { ...menuItem, link: { id: link.id, link: link.link, type: link.type } };
};
